import React, { Component } from 'react';
import golbeldata from '../data.json';
import Appnav from './Appnav.js'
import AppFooter from './Footer.js'
import AppTopHeader from './AppTopHeader.js'
import { Link, Route, Switch } from 'react-router-dom';

class Gallery extends Component {
    constructor(props) {
        super(props);

        this.concerts = golbeldata;
    }

    componentDidMount() {
        document.title = this.concerts.HotelName+" Gallery";
        if (window.jQuery().prettyPhoto) {
            window.jQuery('a[data-rel]').each(function () {
                window.jQuery(this).attr('rel',  window.jQuery(this).data('rel'));
            });
    
            window.jQuery("a[rel^='prettyPhoto']").prettyPhoto({
                social_tools: false,
                animation_speed: 'normal', // fast/slow/normal 
                slideshow: 5000, // false OR interval time in ms
                autoplay_slideshow: false, // true/false
                opacity: 0.80, // Value between 0 and 1 
                show_title: true, // true/false            
                allow_resize: true, // Resize the photos bigger than viewport. true/false
                default_width: 500,
                default_height: 344,
                counter_separator_label: '/', // The separator for the gallery counter 1 "of" 2
                theme: 'pp_default', // light_rounded / dark_rounded / light_square / dark_square / facebook
                horizontal_padding: 20, // The padding on each side of the picture 
                hideflash: false, // Hides all the flash object on a page, set to TRUE if flash appears over prettyPhoto
                wmode: 'opaque', // Set the flash wmode attribute
                autoplay: true, // Automatically start videos: True/False 
                modal: false, // If set to true, only the close button will close the window
                deeplinking: true, // Allow prettyPhoto to update the url to enable deeplinking. 
                overlay_gallery: true, // If set to true, a gallery will overlay the fullscreen image on mouse over 
                keyboard_shortcuts: true, // Set to false if you open forms inside prettyPhoto 
                changepicturecallback: function () {}, // Called everytime an item is shown/changed 
                callback: function () {}, // Called when prettyPhoto is closed
            });
        }  
    }

    render() {
        console.log(this.concerts.HotelName);
        return (
            <div>
                <AppTopHeader data={this.concerts} />
                <header>
                    <Appnav data={this.concerts} />
                </header>
                <section class="parallax-effect">
                    <div id="parallax-pagetitle" style={{ backgroundImage: 'url("images/parallax/' + this.concerts.parllex + '")' }}>
                        <div class="color-overlay">

                            <div class="container">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <ol class="breadcrumb">
                                            <li><a href="index.html">Home</a></li>
                                            <li class="active">Gallery</li>
                                        </ol>
                                        <h1>Gallery</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                
                <section id="gallery" class="mt50">
                    <div class="container">
                        <div class="row gallery">
                        {
                            this.concerts.GalleryHomeImage.map(function (item) {
                                return <div class="col-sm-3 restaurant "><a href={'images/gallery/' + item.Path} data-rel="prettyPhoto[gallery1]"><img src={'images/gallery/' + item.Path} alt="Image 1" style={{ height:"200px"}} /><i class="fa fa-search"></i></a></div>;
                            })
                        }
                        </div>
                    </div>
                </section>
                <AppFooter data={this.concerts} />
                <div id="go-top"><i class="fa fa-angle-up fa-2x"></i></div>

            </div>
        )
    }
}
export default Gallery;


// WEBPACK FOOTER //
// ./src/components/Gallery.js